<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .profile-info {
    margin-top: utils.in_rem(8px);
  }

  .profile-extras {
    margin-top: utils.in_rem(8px);
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: utils.in_rem(8px);
  }

  .salary-info {
    margin-top: utils.in_rem(20px);
  }
</style>

<script>
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import ContactCtasContainer from "../../../elements/ProfileContactSideBarShared/ContactCtas/ContactCtasContainer.svelte";
  import {
    candidateApiStore,
    candidateStore,
    todosModalItemStore,
  } from "../stores";
  import CandidateCachedOptions from "./CandidateCachedOptions.svelte";
  import CandidateInformation from "./CandidateInformation.svelte";
  import CandidateTags from "./CandidateTags.svelte";
  import SalaryInformation from "./SalaryInformation.svelte";
  import SocialAndCrmContainer from "./SocialAndCrmIcons/SocialAndCrmContainer.svelte";

  const { meta } = candidateApiStore;

  let isFromCache = $derived(
    $todosModalItemStore?.fromCache && $todosModalItemStore?.toDoId
  );

  let addToCampaignCta = $derived(
    $userStore.scheduleCampaigns
      ? !$candidateStore?.pendingCampaignIds?.length
      : $candidateStore.status !== "active"
  );
</script>

<div class="profile-info">
  <CandidateInformation />
</div>
{#if isFromCache}
  <CandidateCachedOptions />
{:else}
  <div class="profile-extras">
    <SocialAndCrmContainer />
    <CandidateTags />
  </div>
  {#if $meta.firstFetchDone && $userStore.hasCrm}
    <div class="salary-info">
      <SalaryInformation />
    </div>
  {/if}
  <ContactCtasContainer
    callDropdownCta
    sendWhatsappButtonCta
    sendSmsCta
    logActivityCta
    {addToCampaignCta}
    addManualToDoCta={$userStore.hasCrm}
    style="margin-top: 0.75rem; padding-top: 0.5rem; overflow: visible;"
  />
{/if}
